export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#2A4C35] text-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10" style={{ backgroundImage: 'url(https://readdy.ai/api/search-image?query=tropical%20leaves%20pattern%20dark%20background%20palm%20fronds%20botanical%20illustration&width=1920&height=800&seq=footer-pattern&orientation=landscape)', backgroundSize: 'cover' }}></div>
      
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16 relative z-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12 mb-8 md:mb-12">
          {/* Column 1 - Logo & Tagline */}
          <div>
            <h3 className="text-2xl md:text-3xl font-bold mb-3 md:mb-4" style={{ fontFamily: 'Pacifico, cursive' }}>
              Le Bokal Givré
            </h3>
            <p className="text-[#F5E6D3] mb-4 md:mb-6 leading-relaxed text-sm md:text-base">
              @lebokalgivre on aime vous faire plaisir 🍍
            </p>
            <div className="flex gap-3 md:gap-4">
              <a
                href="https://www.instagram.com/lebokalgivre/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-full border-2 border-white text-white hover:bg-[#FF8F6B] hover:border-[#FF8F6B] transition-all cursor-pointer"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a
                href="https://www.facebook.com/100063594639194"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-full border-2 border-white text-white hover:bg-[#FF8F6B] hover:border-[#FF8F6B] transition-all cursor-pointer"
              >
                <i className="ri-facebook-fill text-lg"></i>
              </a>
            </div>
          </div>

          {/* Column 2 - Horaires */}
          <div>
            <h4 className="text-lg md:text-xl font-bold mb-3 md:mb-4 text-white">Horaires</h4>
            <div className="space-y-2 text-[#F5E6D3] text-sm md:text-base">
              <p className="font-semibold text-white">🥞 Brunch - Lundi</p>
              <p className="text-sm">11h-14h</p>
              <p className="font-semibold text-white mt-3 md:mt-4">🥞 Brunch - Sam & Dim</p>
              <p className="text-sm">10h-12h / 13h-15h</p>
              <p className="font-semibold text-white mt-3 md:mt-4">🍹 Bar & Tapas - Jeu, Dim, Lun</p>
              <p className="text-sm">17h30-22h</p>
              <p className="font-semibold text-white mt-3 md:mt-4">🍹 Bar & Tapas - Ven & Sam</p>
              <p className="text-sm">17h30-23h</p>
            </div>
          </div>

          {/* Column 3 - Contact */}
          <div>
            <h4 className="text-lg md:text-xl font-bold mb-3 md:mb-4 text-white">Contact</h4>
            <div className="space-y-3 text-[#F5E6D3] text-sm md:text-base">
              <div className="flex items-start gap-2">
                <i className="ri-phone-line mt-1 flex-shrink-0"></i>
                <a href="tel:+262693527676" className="hover:text-[#FF8F6B] transition-colors cursor-pointer break-words">
                  +262 693 52 76 76
                </a>
              </div>
              <div className="flex items-start gap-2">
                <i className="ri-mail-line mt-1 flex-shrink-0"></i>
                <a href="mailto:lebokalgivre.cie@gmail.com" className="hover:text-[#FF8F6B] transition-colors cursor-pointer break-words">
                  lebokalgivre.cie@gmail.com
                </a>
              </div>
              <div className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-1 flex-shrink-0"></i>
                <p className="text-sm">
                  52 Chemin Edward Savigny<br />
                  Ligne des Bambous<br />
                  97432 Saint-Pierre, Réunion
                </p>
              </div>
            </div>
          </div>

          {/* Column 4 - Navigation */}
          <div>
            <h4 className="text-lg md:text-xl font-bold mb-3 md:mb-4 text-white">Navigation</h4>
            <div className="space-y-2 text-sm md:text-base">
              <button onClick={() => scrollToSection('brunch')} className="block text-[#F5E6D3] hover:text-[#FF8F6B] transition-colors cursor-pointer whitespace-nowrap">
                Brunch
              </button>
              <button onClick={() => scrollToSection('restaurant')} className="block text-[#F5E6D3] hover:text-[#FF8F6B] transition-colors cursor-pointer whitespace-nowrap">
                Restaurant & Tapas
              </button>
              <button onClick={() => scrollToSection('bar')} className="block text-[#F5E6D3] hover:text-[#FF8F6B] transition-colors cursor-pointer whitespace-nowrap">
                Bar
              </button>
              <button onClick={() => scrollToSection('reservation')} className="block text-[#F5E6D3] hover:text-[#FF8F6B] transition-colors cursor-pointer whitespace-nowrap">
                Réserver
              </button>
              <button onClick={() => scrollToSection('contact')} className="block text-[#F5E6D3] hover:text-[#FF8F6B] transition-colors cursor-pointer whitespace-nowrap">
                Contact
              </button>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-[#F5E6D3]/20 pt-6 md:pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-3 md:gap-4 text-[#F5E6D3] text-xs md:text-sm text-center md:text-left">
            <p>© 2025 Le Bokal Givré. Tous droits réservés.</p>
            <p className="flex flex-wrap items-center justify-center gap-2">
              <span>Fait avec 🥥 à La Réunion</span>
              <span className="hidden md:inline">|</span>
              <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="hover:text-[#FF8F6B] transition-colors cursor-pointer whitespace-nowrap">Powered by Readdy</a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
